package one.healthium.onboarding.ui.components

import androidx.compose.runtime.Composable
import one.healthium.onboarding.domain.configs.Notification

@Composable
actual fun Notification(notification: Notification) {
    // TODO
}